import Vue from "vue";

// A module-level event bus shared by every <timetable> instance on the page.
// Timetables that opt in with the same `sync-group` mirror each other's active
// date and view, so switching between them (e.g. tabs on the instructor schedule)
// keeps the same week in view.
export const sharedTimetableBus = new Vue();
